define([
	'jquery',
	'pubsub',
    'wcs.utils'
	], function($,pubsub,utils) {

	var PLUGIN_IDENTIFIER = "mainscroll";
	var mainscroll = function( element, options ) {
		this.element = element;
		this.options = options;
	};

	mainscroll.prototype = {
		defaults: {
			scrollThreshold: 100, // Minimum distance in pixels that triggers a scroll event
			rateLimit: 150 // Limit how often event fires by waiting this many miliseconds
		},

		init: function() {
			var self = this;
			
			// Merge the options and defaults into a config object
			self.config = $.extend( {}, self.defaults, self.options);

			// Cache selectors
			self.$element = $(self.element);

			// Calculate the current scroll location
			self.config.currentScroll = self.$element.scrollTop();

			self.events();

			return self;
		},

		/***
		 * Setup event handlers and event publishers
		 ***/
		events: function() {
			var self = this;

			self.initScrollEvents();
		},

		// https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
		throttle: function(func, limit){
			var lastFunc,
			  lastRan;
			return function() {
				var context = this,
					args = arguments;
				if (!lastRan) {
					func.apply(context, args);
					lastRan = Date.now();
				} else {
					clearTimeout(lastFunc);
					lastFunc = setTimeout(function() {
						if ((Date.now() - lastRan) >= limit) {
							func.apply(context, args);
							lastRan = Date.now();
						}
					}, limit - (Date.now() - lastRan));
				}
          	};
        },

		/**
		 * Setup a global pubsub event for window scrolling
		 *
		 * Better performance - This reduces the number of
		 * window resize event listeners.
		 *
		 * Better performance - Reduce how often event fires
		 * while actively resizing by using a delay
		 *
		 * Setup a global pubsub event that fires only when the user is done scrolling.
		 *
		 * Publishes an event with new breakpoint in the name.
		 * Event data contains the old and new scroll location
		 *    data: { "was": 123, "now": 456 }
		 * 
		 * Usage Examples:
		 *
		 *    Listen for a window scroll and check the position after scrolling is done
		 *    $.pubsub('subscribe', 'window.scroll', function(event, data) {
		 *      // runs at the completion of any window scroll
		 *      console.log('window was at ', data.was);
		 *      console.log('window is now at ', data.now);
		 *		console.log('window scrolled ', data.now - data.was);
		 *    });
		 **/
		initScrollEvents: function() {
			var self = this;

			// Setup rate limit on callback
			var callback = self.throttle(function() {

				var data = {
					was: self.config.currentScroll,
					now: self.$element.scrollTop()
				};

				$.pubsub('publish', 'window.scroll', data);
				// Update stored scroll so we're ready for the next scroll event
				self.config.currentScroll = data.now;

			},self.config.rateLimit);
			window.addEventListener( 'scroll', callback );
		},

	};

	mainscroll.defaults = mainscroll.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.mainscroll = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new mainscroll(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);

				// attach to the window.main object for consistency
				window.main = window.main || {};
				window.main.scroll = window.main.scroll || instance;
			}
		});
	};

	// Initialize by attaching to the scrolling element based on browser support. Keeping 'html' for IE backwards compatibility.
	$(document.scrollingElement || 'html').mainscroll();
});